<div class="pos-absolute left-0 right-0 top-0 w-12 pe-none overflow-hidden meganav-content">
    <div class="b-t ng-hide ng-hide-animate meganav-content__inner overflow-hidden"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="meganavToggleGroupId"
         [elementHeight]="'meganav'">
        <ng-container *ngFor="let item of items; let i = index;">
            <div class="w-12 m-r--100 p-t-9 hide-fade ng-hide ng-hide-animate meganav-content__item overflow-hidden "
                 [toggleClass]="'!ng-hide'"
                 [toggleClassBy]="[meganavToggleGroupId, i + (tabIndex * 20)]"
                 pageHeaderMeganavContentArea
                 (mouseenter)="handleMouseEnter(i)"
                 (mouseleave)="handleMouseLeave(i)">
                <div class="wrap">
                    @for (column of item.columns; track column; let isLast = $last;) {
                    <div class="m-b-0"
                         [ngClass]="[column.width || 'c-3', isLast ? 'm-r-0':'']">
                        @for (element of column.list; track element) {
                        <ng-container [ngSwitch]="element.variant">

                            <p class="s1 col-1"
                               *iCms="'title' of element; content: 'html'; skipEmpty: true"></p>

                            <ul *ngSwitchCase="'links_list'"
                                class="m-b-9">
                                @for (line of element.linksList; track line) {
                                <li class="m-t-3 _slight-right"
                                    [ngClass]="line.withImage || line.withColours ? 'flex flex-middle' : ''"
                                    [gtmTrackNavigationClick]="{
                                        event: 'nav_subcategory_item_click',
                                        nav_category: item.text,
                                        link_url: line.link,
                                        link_text: line.text,
                                        nav_subcategory: element.gtmSubcategory}">
                                    <div *ngIf="line.withImage"
                                         class="w-3 ratio-1-1 m-r-2">
                                        <href [link]="line.link">
                                            <img class="rf"
                                                 [image]="line.image">
                                        </href>
                                    </div>
                                    <div *ngIf="line.withColours"
                                         class="ratio-1-1 m-r-2 inline-block"
                                         style="height:1.2rem; width:1.2rem;">
                                        <div class="rf b-radius-max"
                                             [ngClass]="line.extraBorder ? 'b-a b-col-4' : '' "
                                             [ngStyle]="{'background-color': line.colour || 'rgb(255, 255, 255)'}">
                                        </div>
                                    </div>
                                    <href class="p2 col-11"
                                          [link]="line.link">
                                        <span *iCms="'text' of line"></span>
                                    </href>
                                </li>
                                }
                            </ul>
                            <div *ngSwitchCase="'image'"
                                 [gtmTrackNavigationClick]="{  event: 'nav_image_click',
                                                                nav_category: item.text,
                                                                link_url: element.link,
                                                                link_text: element.text }"
                                 class="m-b-9">

                                <href [link]="element.link">
                                    <div class="w-12"
                                         [ngClass]="element.ratio || 'ratio-1-1'"
                                         *ngIf="element.image">
                                        <img class="rf"
                                             [image]="element.image"
                                             dynamic="1">
                                        <div class="pos-absolute bottom-0 right-0 col-w bg-col-2 p-t-1 p-b-1 p-r-2 p-l-2 c1"
                                             style="border-radius: 10px 0 0 0"
                                             *iCms="'label' of element; skipEmpty: true"></div>
                                    </div>
                                    <p class="s2 col-1 m-t-3 center"
                                       *iCms="'text' of element"></p>
                                </href>
                            </div>


                            <div *ngSwitchCase="'cta'">
                                <div class="ratio-1-1">
                                    <div class="rf">
                                        <div class="vc-outer">
                                            <div class="vc-inner">
                                                <href [link]="element.cta_url">
                                                    <div class="flex flex-middle flex-justify-center m-t-8-l">
                                                        <p class="s2 col-1"
                                                           *iCms="'cta_label' of element"></p>
                                                        <i class="m-l-3 icon-chevron-right"
                                                           [style.font-size.rem]="1.5"
                                                           [style.line-height.rem]="1.25"></i>
                                                    </div>
                                                </href>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        }
                    </div>
                    }
                </div>

                <div *ngIf="item.promo_copy"
                     class="center p-t-3 p-b-3"
                     [ngStyle]="{'background-color': item.promo_background_colour || 'rgb(255, 255, 255)'}"
                     [ngClass]="item.promo_copy_colour || 'col-1'">
                    <p class="p2 inline-block"
                       *iCms="'promo_copy' of item"></p>

                    @for (cta of item.promo_ctas; track cta) {
                    <a class="p2 underline m-l"
                       [routerLink]="cta.promo_cta_url"
                       *iCms="'promo_cta_label' of cta">
                    </a>
                    }
                </div>
            </div>
        </ng-container>
    </div>
</div>
